export default function FfnManagementPopupController(
    selectedSeatsService,
    clubCard,
    selectedSeats,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        isFfnUsedForSeatSelection,
    });

    function isFfnUsedForSeatSelection() {
        return selectedSeatsService.isFfnUsedForSeatSelection(clubCard, selectedSeats);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/adult/ffn-management/ffn-management-popup-controller.js